import {
  Button,
  Container,
  FormControl,
  Grid,
  Input,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "axios";
import React, { Component } from "react";
import Constants from "../App/Variables/Constants";
import init from "../helpers/WindowToken";
export default class UpdateProduct extends Component {
  state = {
    title: "",
    description: "",
    loading: false,
    blogId: "",
    posterImage: "",
    modelFile: "",
    is_model_available: "",
    categories: [],
  };
  componentDidMount() {
    // console.log(this.props);
    let data = this.props.location.state.data;
    this.getcategories();
    this.setState(
      {
        prId: data._id,
        title: data.title,
        description: data.description,
        posterImage: data.posterImage,
        modelFile: data.modelFile,
        is_model_available: data.is_model_available,
        categories: data.categories,
      },
      () => {
        // console.log(this.state.blogId);
      }
    );
  }
  updateproducts = (e) => {
    this.setState({
      loading: true,
    });
    e.preventDefault();
    let productload = {
      title: this.state.title,
      description: this.state.description,
      posterImage: this.state.posterImage,
      modelFile: this.state.modelFile,
      is_model_available: this.state.is_model_available,
      categories: this.state.categories,
    };
    // console.log(productload);
    if (init() === "success") {
      axios
        .put(Constants.getUrls.Products + "/" + this.state.prId, productload)
        .then((resp) => {
          // console.log(resp);
          if (resp.data.status === "success") {
            this.setState({
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState({
                redirect: true,
              });
            }, 1000);
            this.setState({
              notification: true,
              loading: false,
            });
          } else {
            this.setState({
              warn: true,
              loading: false,
            });
            setTimeout(() => {
              this.setState({
                warn: false,
              });
            }, 1000);
          }
        });
    }
  };
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  getcategories = () => {
    axios.get(Constants.getUrls.Categories).then((resp) => {
      // console.log(resp);
      this.setState({
        categories: resp.data.categories.docs,
      });
    });
  };
  render() {
    return (
      <Container maxWidth="xl">
        <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
          <Grid item xs={6}>
            <Typography variant="h6">{this.props.title}</Typography>
          </Grid>
        </Grid>
        {this.state.notification ? (
          <div
            style={{
              width: "228px",
              position: "relative",
              left: "13%",
              top: "7px",
              borderRadius: "6px",
              background: "Green",
              padding: "13px",
            }}
          >
            <Typography>{this.state.message}!</Typography>
          </div>
        ) : null}
        <Grid item sm={12} style={{ textAlign: "center" }}>
          <form noValidate autoComplete="off" onSubmit={this.updateproducts}>
            <TextField
              id="outlined-basic"
              onChange={this.handleInput}
              label="Title"
              name="title"
              variant="outlined"
              value={this.state.title}
              style={{ marginRight: "20px", width: "30%" }}
            />
            <TextField
              id="outlined-basic"
              label="Description"
              onChange={this.handleInput}
              name="description"
              value={this.state.description}
              variant="outlined"
              style={{ marginRight: "20px", width: "30%" }}
            />
            <label htmlFor=""> Poster Image</label>
            <Input
              type="file"
              name="posterImage"
              value={this.state.posterImage}
            />
            <label htmlFor=""> Model File</label>
            <Input
              type="file"
              name="is_model_available"
              value={this.state.is_model_available}
            />
            <FormControl
              style={{ marginTop: "12px" }}
              fullWidth
              // className={classes.selectFormControl}
            >
              <InputLabel
                htmlFor="simple-select"
                // className={classes.selectLabel}
              >
                Main Category
              </InputLabel>
              <Select
                MenuProps={
                  {
                    // className: classes.selectMenu
                  }
                }
                classes={
                  {
                    // select: classes.select
                  }
                }
                inputProps={{
                  name: "categories",
                  id: "simple-select",
                  value: this.state.categories,
                  onChange: this.handleInput,
                }}
              >
                {this.state.categories.map((cat, index) => (
                  <MenuItem
                    // classes={{
                    //   // root: classes.selectMenuItem,
                    //   // selected: classes.selectMenuItemSelected
                    // }}
                    key={index}
                    value={cat.id}
                  >
                    {cat.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <br />
            <Button
              variant="contained"
              type="submit"
              Size={15}
              color="primary"
              style={{ marginRight: "20px", marginTop: "20px" }}
            >
              {this.state.loading ? "Adding.." : "Update Product"}
            </Button>
          </form>
        </Grid>
      </Container>
    );
  }
}
